import {
  DateRangeFieldType,
  formApiAdapterRegistry,
} from '../registry/form-api-adapter.registry';
import { adaptFormFieldWarnings } from '../utilities/adaptFormFieldWarningsResponse';
import { DateRangeFormField, IFormBase } from '@/forms/typings';
import {
  DateFormFieldBuilder,
  DateRangeFormFieldBuilder,
} from '@/forms/builders';
import { FormDateRangeFieldResponseDTO } from '@/api/base/DTOs';

export const adaptFormDateRangeFieldsResponseToDateRangeFormField = (
  formDateRangeFieldsResponse: FormDateRangeFieldResponseDTO,
  parentFieldId?: IFormBase['fieldId'],
): DateRangeFormField => {
  let fromDateField = new DateFormFieldBuilder()
    .fieldId(formDateRangeFieldsResponse.fromFieldID)
    .name(formDateRangeFieldsResponse.fromFieldID)
    .label(formDateRangeFieldsResponse.fromName)
    .value(formDateRangeFieldsResponse.fromValue)
    // TODO: Check if this is correct
    .readonly(!formDateRangeFieldsResponse.isFromEditable)
    .parentFieldId(formDateRangeFieldsResponse.fieldID)
    .placeholder(formDateRangeFieldsResponse.hint);

  const fromDateValidations = formApiAdapterRegistry.adaptDateRange(
    DateRangeFieldType.From,
    formDateRangeFieldsResponse.restriction,
  );

  if (fromDateValidations) {
    fromDateField = fromDateField.validations(fromDateValidations);
  }

  let toDateField = new DateFormFieldBuilder()
    .fieldId(formDateRangeFieldsResponse.toFieldID)
    .name(formDateRangeFieldsResponse.toFieldID)
    .label(formDateRangeFieldsResponse.toName)
    .value(formDateRangeFieldsResponse.toValue)
    // TODO: Check if this is correct
    .readonly(!formDateRangeFieldsResponse.isToEditable)
    .parentFieldId(formDateRangeFieldsResponse.fieldID)
    .placeholder(formDateRangeFieldsResponse.hint);

  const toDateValidations = formApiAdapterRegistry.adaptDateRange(
    DateRangeFieldType.To,
    formDateRangeFieldsResponse.restriction,
  );

  if (toDateValidations) {
    toDateField = toDateField.validations(toDateValidations);
  }

  const toField = toDateField.build();
  const toWarnings = adaptFormFieldWarnings(
    formDateRangeFieldsResponse.restriction?.toWarnings,
  );

  if (toWarnings) {
    toField.warnings = toWarnings;
  }

  return new DateRangeFormFieldBuilder()
    .fieldId(formDateRangeFieldsResponse.fieldID)
    .hasAnyValue(formDateRangeFieldsResponse.hasAnyValue)
    .notApplicable(formDateRangeFieldsResponse.notApplicable)
    .showNotApplicable(formDateRangeFieldsResponse.showNotApplicable)
    .parentFieldId(parentFieldId)
    .fields([fromDateField.build(), toField])
    .build();
};
